import { render } from "./getSmsCode.vue?vue&type=template&id=77426058"
import script from "./getSmsCode.vue?vue&type=script&lang=js"
export * from "./getSmsCode.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__